import { endPoints } from 'api/';
import { NOTIFICATION_SETTINGS } from 'actions/types';

/**
 * @description Sets notification setting object
 * @param {Object} payload
 * @returns Setting object
 */
export function notificationSetting(payload) {
  /**
   * @param {Function} dispatch
   */
  return function (dispatch) {
    const action = {
      type: NOTIFICATION_SETTINGS,
      /**
       * @param {Function} apiClient
       */
      request: async function (apiClient) {
        return await apiClient(endPoints.NOTIFICATION_SETTINGS, payload);
      },
    };
    dispatch(action);
  };
}
